import React, { createContext, useState } from 'react'

const UserContext = createContext();

export const UserProvider = ({ children }) => {
    const [userData, setUserdata] = useState({})

    const handleUserChange = (name, value) => {
        setUserdata((prevUser) => ({
            ...prevUser,
            [name]: value,
        }))
    }

    return (
        <UserContext.Provider value={{ userData, handleUserChange }}>
            {children}
        </UserContext.Provider>
    )
}

export const useUserContext = () => React.useContext(UserContext)
